import axiosBackEnd from "../../config/axios/axios-back-end";

// Self service - get all corp contacts
const getAllCorporateContacts = async () => {
  const response = await axiosBackEnd.get("/api/onboarding/corporate-contacts");
  return response.data;
};

// Self service - ceate corp contacts
const createCorporateContact = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/corporate-contacts`,
    data,
  );
  return res.data;
};

// Self service - update corp contacts
const updateCorporateContact = async (data) => {
  const res = await axiosBackEnd.put(
    `/api/onboarding/corporate-contacts/${data._id}`,
    data,
  );
  return res.data;
};

export {
  getAllCorporateContacts,
  createCorporateContact,
  updateCorporateContact,
};
